<div class="tabs">
    <div *ngFor="let iTab of tabs" [ngClass]="{ 'active': iTab.active, 'invisible': !iTab.show }" (click)="onTabClick(iTab)">{{iTab.title}}</div>
    <div *ngFor="let iTab of fakeTabs; let i = index" [ngClass]="{ 'active': true, 'fake_start': i === 0, 'fake': true, 'fake_end': i === (fakeTabs.length - 1) }">&nbsp;</div>
</div>

<div class="tab_content">
    <ng-container *ngTemplateOutlet="activeTemplate"></ng-container>
</div>
